<template>
  <div>
    <b-row v-if="!areas.length" class="d-flex justify-content-center pt-5">
      <h1 class="text-center">{{ $t('no_reviewed_areas') }}</h1>
    </b-row>

    <b-row v-else>
      <b-col v-for="(area, index) in areas" :key="index" md="6" lg="4" class="mb-1">
        <review-card-item :title="area.name" :reviews="area.reviews" :link="area.id" @view-area-reviews="($event, id) => onViewAreaReviews($event, id)" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import { mapState } from 'vuex'
import ToastificationContent from '@hw-ui/components/toastification/ToastificationContent.vue'
import ReviewCardItem from '../shared/ReviewCardItem.vue'

export default {
  components: {
    BRow,
    BCol,

    ReviewCardItem,
  },
  data() {
    return {
      selectedArea: null,
      currentUser: null,
      currentPage: 1,
      actionChangePage: '',
    }
  },
  computed: {
    ...mapState('appAccount', ['selectedAccount']),
    ...mapState('appReview', { areas: 'areas' }),
  },
  mounted() {
    try {
      this.fetchAreaList()
    } catch (error) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: this.$t('error_fetch_areas'),
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
    }
  },
  methods: {
    fetchAreaList() {
      this.$store.dispatch('appReview/fetchAreas', { accountId: this.selectedAccount.value.id })
    },
    onViewAreaReviews(event, id) {
      if (!id?.length) {
        return
      }

      event.preventDefault()
      this.$router.push({
        name: 'apps-reviews-view',
        params: {
          id,
        }
      }) 
    },
  },
}
</script>
